import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueLocalStorage from 'vue-localstorage'

import { jwtDecode, jwtExpired, toDate } from './index'

if ( !Vue.localStorage )
{
	Vue.use(VueLocalStorage, { bind: true })
}

const USER_TOKEN     = 'token'
const EMPLOYEE_TOKEN = 'employee_token'

export default
{
	parseToken()
	{
		return jwtDecode(this.getToken())
	},

	hasToken()
	{
		return !!this.getToken()
	},

	getToken()
	{
		return Vue.localStorage.get(USER_TOKEN, '')
	},

	setToken(token)
	{
		Vue.localStorage.set(USER_TOKEN, token)
	},

	removeToken()
	{
		Vue.localStorage.remove(USER_TOKEN)
	},

	expiresAt()
	{
		if ( !this.hasToken() )
		{
			return
		}

		const { exp } = this.parseToken() ?? {}

		return toDate(exp)
	},

	expiresIn()
	{
		if ( !this.hasToken() )
		{
			return
		}

		return this.expiresAt()?.getTime() - ( new Date ).getTime()
	},

	hasExpiredToken()
	{
		return !this.hasToken() || jwtExpired(this.parseToken())
	},

	parseEmployeeToken()
	{
		return jwtDecode(this.getEmployeeToken())
	},

	hasEmployeeToken()
	{
		return !!this.getEmployeeToken()
	},

	getEmployeeToken()
	{
		return VueCookies.get(EMPLOYEE_TOKEN)
	},

	setEmployeeToken(token)
	{
		VueCookies.set(EMPLOYEE_TOKEN, token)
	},

	removeEmployeeToken()
	{
		VueCookies.remove(EMPLOYEE_TOKEN)
	},
}